export const LANGUAGE = 'LANGUAGE'
export const REGION = 'REGION'
export const CITY = 'CITY'
export const DISTRICT = 'DISTRICT'
